import { module } from 'modujs';
import { html } from '../utils/environment'
import { lerp } from '../utils/maths'
import { transform } from '../utils/transform'

const CLASS = {
    ACTIVE: `is-active`
}

export default class extends module {
    constructor(m) {
        super(m);
    }

    init(){
        if(window.isMobile) return

        this.mouse = {
            x: 0,
            y: 0,
            lerpedX: 0,
            lerpedY: 0
        }

        this.bindMousemove = this.mousemove.bind(this);
        window.addEventListener('mousemove',this.bindMousemove);
    }

    animate() {
        this.raf = requestAnimationFrame(() => this.animate());

        this.mouse.lerpedX = lerp(this.mouse.lerpedX, this.mouse.x, 0.1);
        this.mouse.lerpedY = lerp(this.mouse.lerpedY, this.mouse.y, 0.1);

        transform(this.$('cursor')[0],`translate3d(${this.mouse.lerpedX}px,${this.mouse.lerpedY}px,0)`)
    }

    mousemove(e) {
        if(window.isMobile) return;

        this.mouse.x = e.clientX;
        this.mouse.y = e.clientY;
    }

    show(e) {
        if(window.isMobile) return


        this.$('cursor')[0].classList.add('is-active')
        this.$('img')[0].setAttribute("style", `background-image: url(${e.img});`);

        this.animate()
    }

    hide() {
        if(window.isMobile) return

        this.$('cursor')[0].classList.remove('is-active')

        cancelAnimationFrame(this.raf)
    }

    destroy(){
        if(window.isMobile) return

        cancelAnimationFrame(this.raf)
    }
}
